<template>
  <div class="disable-scroll-x">
    <meta v-if="metaInfo.link" v-for="(link, index) in metaInfo.link" :key="index" :href="link.href" :rel="link.rel">
  </div>
</template>

<script>
import VueMeta from "vue-meta";
import Vue from "vue";
import { mapGetters } from "vuex";

export default {
  name: "Login",
  data() {
    return {};
  },
  created() {
    Vue.use(VueMeta);
    AOS.init();
  },
  computed: {
    ...mapGetters({
      canonicalUrl: "getCanonicalUrl",
    }),
  },
  metaInfo() {
    const meta = {};
    if (this.canonicalUrl) {
      meta.link = [{ rel: 'canonical', href: this.canonicalUrl }];
    }
    return meta;
  },
};
</script>